.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-drawer);
  background: var(--color-overlay);
  display: flex;
  justify-content: flex-end;
  animation: fade 0.15s var(--ease);
}
.panel {
  width: min(480px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  border-inline-start: 1px solid var(--color-border);
  box-shadow: var(--shadow-lg);
  animation: slide 0.22s var(--ease);
}
.panel:focus {
  outline: none;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-6);
  border-block-end: 1px solid var(--color-border);
}
.title {
  font-size: var(--text-xl);
  font-weight: 700;
}
.desc {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  margin-block-start: 4px;
}
.body {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-6);
}
.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-6);
  border-block-start: 1px solid var(--color-border);
}
@keyframes fade {
  from {
    opacity: 0;
  }
}
@keyframes slide {
  from {
    transform: translateX(32px);
    opacity: 0;
  }
}
[dir='rtl'] .panel {
  animation-name: slideRtl;
}
@keyframes slideRtl {
  from {
    transform: translateX(-32px);
    opacity: 0;
  }
}
